import { Auth } from 'aws-amplify'
import { Component } from 'react'
import FormErrors from '../../FormErrors'

class ChangePassword extends Component {
  state = {
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
    errors: {
      cognito: null,
      blankfield: false,
      passwordmatch: false,
    },
  }

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false,
      },
    })
  }

  handleSubmit = async (event) => {
    event.preventDefault()

    // Form validation
    this.clearErrorState()

    // AWS Cognito integration here
    try {
      const user = await Auth.currentAuthenticatedUser()

      await Auth.changePassword(
        user,
        this.state.oldpassword,
        this.state.newpassword,
      )
      this.props.history.push('/changepasswordconfirmation')
    } catch (error) {
      let err = null
      !error.message ? (err = { message: error }) : (err = error)
      this.setState({
        errors: { ...this.state.errors, cognito: err },
      })
      console.log(err)
    }
  }

  onInputChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    })
    document.getElementById(event.target.id).classList.remove('is-danger')
  }

  render() {
    return (
      <section className="section auth">
        <div className="container">
          <h1>Change Password</h1>
          <FormErrors formerrors={this.state.errors} />

          <form onSubmit={this.handleSubmit}>
            <div className="field">
              <p className="control has-icons-left">
                <input
                  className="input"
                  type="password"
                  id="oldpassword"
                  placeholder="Old password"
                  value={this.state.oldpassword}
                  onChange={this.onInputChange}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-lock"></i>
                </span>
              </p>
            </div>
            <div className="field">
              <p className="control has-icons-left">
                <input
                  className="input"
                  type="password"
                  id="newpassword"
                  placeholder="New password"
                  value={this.state.newpassword}
                  onChange={this.onInputChange}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-lock"></i>
                </span>
              </p>
            </div>
            <div className="field">
              <p className="control has-icons-left">
                <input
                  className="input"
                  type="password"
                  id="confirmpassword"
                  placeholder="Confirm password"
                  value={this.state.confirmpassword}
                  onChange={this.onInputChange}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-lock"></i>
                </span>
              </p>
            </div>
            <div className="field">
              <p className="control">
                <a href="/forgotpassword">Forgot password?</a>
              </p>
            </div>
            <div className="field">
              <p className="control">
                <button className="button is-success">Change password</button>
              </p>
            </div>
          </form>
        </div>
      </section>
    )
  }
}

export default ChangePassword
